import React from 'react';
export const RegistrationContext = React.createContext({});
//# sourceMappingURL=RegistrationContext.js.map